import { render } from "./SystemCsvTranslationExport.vue?vue&type=template&id=1b5eb7d6&ts=true"
import script from "./SystemCsvTranslationExport.vue?vue&type=script&lang=ts"
export * from "./SystemCsvTranslationExport.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__